import type { ComponentProps } from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { CheckIcon, MinusIcon } from "lucide-react";

import { cn } from "@/lib/utils";

function Checkbox({ className, ...props }: ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        "peer m-0 text-base font-medium bg-white border-border-bold hover:bg-subtle focus-visible:ring-ring focus-visible:border-border-bold \
        data-[state=checked]:bg-foreground data-[state=indeterminate]:bg-foreground text-inverted-foreground data-[state=checked]:border-foreground data-[state=indeterminate]:border-foreground \
        aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive size-4 shrink-0 border transition-shadow outline-none \
        focus-visible:ring-[1px] disabled:cursor-not-allowed disabled:opacity-50 hover:data-[state=checked]:bg-foreground \
        hover:data-[state=indeterminate]:bg-foreground focus-visible:data-[state=checked]:ring-ring-checkbox \
        focus-visible:data-[state=indeterminate]:ring-ring-checkbox focus-visible:data-[state=checked]:bg-foreground \
        focus-visible:data-[state=indeterminate]:bg-foreground",
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="flex items-center justify-center text-current transition-none"
      >
        {props.checked === "indeterminate" ? (
          <MinusIcon className="size-3.5 text-inverted-foreground" />
        ) : (
          <CheckIcon className="size-3.5 text-inverted-foreground" />
        )}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
